import { Environment } from './types'

type Config = {
  apiEndpoint: string
  baseurl?: string
  instrumentationKey: string
  addressResolverBaseUrl: string
  geoFeaturesApi: string
}

export type EnvironmentConfig = {
  [k in Environment as Environment]: Config
}

const getEnvironment = () =>
  Object.values(Environment).find((value) =>
    window.location.host.includes(value)
  ) || (Environment.PRODUCTION as Environment)

export { getEnvironment }
